module.exports = __webpack_public_path__ + "static/img/skin.71e9889.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pc/skin/5/skin.png
// module id = asPK
// module chunks = 2